<!--
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-06-04 10:43:38
 * @Description: 手机号脱敏
 * @FilePath: /DecryptIdCardV2.vue
-->
<template>
  <span class="decrypt">
    <template v-if="props.phone">
      {{ state.showEye ? props.phone : state.result || '--' }}
      <LoadingOutlined v-show="state.loading" class="ml-4" style="font-size: 16px; color: #e60012" />
      <EyeInvisibleTwoTone
        v-show="!state.loading && state.showEye"
        @click="getCardId"
        class="real-user-show"
        two-tone-color="#e60012"
      />
      <EyeTwoTone
        v-show="!state.loading && !state.showEye"
        @click="getCardId"
        class="real-user-show"
        two-tone-color="#e60012"
      />
    </template>
    <template v-else>
      --
    </template>
  </span>
</template>
<script setup lang="ts" name="DecryptIdCardV2">
  import { reactive } from 'vue'
  import { EyeTwoTone, EyeInvisibleTwoTone, LoadingOutlined } from '@ant-design/icons-vue'
  import { getPhoneService } from '@/service/api'
  import { isSuccess } from '@/utils'
  interface Props {
    id: string | number | undefined
    phone: string | undefined
    /** 场景值
     * 001 查寄件手机号
     * 002收件手机号
     * 003 邮箱
     **/
    scenes: '001' | '002' | '003'
    menuName: string | undefined
  }
  const props = defineProps<Props>()
  /**查看手机号 */
  const state = reactive({
    /** 加载中 */
    loading: false,
    /** 显示眼睛 */
    showEye: true,
    /** 结果 */
    result: ''
  })

  const getCardId = () => {
    if (state.result) {
      state.showEye = !state.showEye
      return
    }
    state.loading = true
    getPhoneService
      .getPhoneV2({
        id: props.id,
        key: props.id,
        code: props.scenes,
        menuName: props.menuName
      })
      .then((res) => {
        if (isSuccess(res)) {
          state.result = res.data
        }
        console.log('res', res)
      })
      .catch((err) => {
        console.log('err', err)
      })
      .finally(() => {
        state.loading = false
        state.showEye = !state.showEye
      })
  }
</script>
<style lang="less" scoped>
  .decrypt {
    display: flex;
    justify-content: center;
    align-items: center;
    .real-user-show {
      cursor: pointer;
      margin-left: 4px;
    }
  }
</style>
